var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCross = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7.442 4.419A1.43 1.43 0 1 0 5.42 6.442l5.058 5.058-5.058 5.058a1.43 1.43 0 1 0 2.023 2.023l5.058-5.058 5.058 5.058a1.43 1.43 0 1 0 2.023-2.023L14.523 11.5l5.058-5.058a1.43 1.43 0 1 0-2.023-2.023L12.5 9.477z",
  clipRule: "evenodd"
})));
export default SvgCross;